export default __webpack_public_path__ + "static/media/payAtCounter.b1825966.png";